const coordTypeLabel: Record<string, string> = {
  POLYGON: 'hranice/linie',
  MULTIPOLYGON: 'hranice/linie',
  LINESTRING: 'hranice/linie',
  MULTILINESTRING: 'hranice/linie',
  POINT: 'definiční bod',
};

const coordTypeLinkLabel: Record<string, string> = {
  POLYGON: '1 oblast na mapě',
  MULTIPOLYGON: 'více oblastí na mapě',
  LINESTRING: 'linie',
  MULTILINESTRING: 'více linií',
};

export const constructMapLinkLabel = (coords: string) => {
  const firstWord = new RegExp(/^([\w-]+)/g);
  const coordType = coords.match(firstWord)?.toString();
  const rest = coords
    .replace(coordType ?? '', '')
    .replace('(', '')
    .replace(')', '')
    .replace(' ', '')
    .replace(' ', ', ');

  if (!coordType) {
    return { linkLabel: 'unknown', labelPrefix: '' };
  }
  if (coordType === 'POINT') {
    return {
      linkLabel: rest,
      labelPrefix: `${
        coordTypeLabel?.[coordType] ?? coordType ?? 'unknown'
      } | GPS: `,
    };
  } else {
    return {
      linkLabel: coordTypeLinkLabel?.[coordType] ?? coordType,
      labelPrefix: `${
        coordTypeLabel?.[coordType] ?? coordType ?? 'unknown'
      } | `,
    };
  }
};

export const constructEadMapLink = (
  eadId: string,
  initialIndex: number
): string => `/map/ead/${initialIndex}/${eadId}`;

export const constructOriginatorMapLink = (
  originatorId: string,
  initialIndex: number
): string => `/map/originator/${initialIndex}/${originatorId}`;
